import { useState, useLayoutEffect, useRef } from 'react';

// auto size hook for ant table only
function useAutoSize() {
    const ref = useRef(null);
    const [tableHeight, setTableHeight] = useState(0);

    useLayoutEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            const { height } = ref.current.getBoundingClientRect();
            console.log(height);
            setTableHeight(height - 64);
        });

        if (ref.current) {
            resizeObserver.observe(ref.current);
        }

        return () => resizeObserver.disconnect();
    }, []);

    return [ref, tableHeight];
}

export default useAutoSize;